/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { HeaderDetectionAlgorithm } from "./HeaderDetectionAlgorithm";
export const HeaderDetectionOptions = core.serialization.object({
    algorithm: HeaderDetectionAlgorithm,
    rowsToSearch: core.serialization.number().optional(),
    skip: core.serialization.number().optional(),
    headers: core.serialization.list(core.serialization.string()).optional(),
    rowNumbers: core.serialization.list(core.serialization.number()).optional(),
});
